import { WBBox, WBButton, WBFlex } from '@admiin-com/ds-web';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { DownloadIcon } from './SignDesktop';
import { SignedBox } from './SignedBox';
import { SignBoxProps } from './types';
import { usePdfScroll } from '../../../../components/PdfSign/PdfScrollContext';
import PageSelector from '../../../../components/PageSelector/PageSelector';
import { BottomDrawer } from '../../../../components/ESignature/BottomDrawer';
import PdfSign from '../../../../components/PdfSign/PdfSign';
import { SignatureFieldMobileContainer } from '../../../../components/ESignature/DragDropField';
import { downloadPdf } from '../../../../helpers/signature';
import { TaskPropertyMobile } from '../../layout/components/TaskProperty/TaskPropertyMobile';
export const SignMobile = (props: SignBoxProps) => {
  const { t } = useTranslation();

  const [started, setStarted] = React.useState<'Sign' | 'Finish'>('Sign');
  const {
    ref,
    isFinish,
    disableNextButton,
    handleMoveIndicator: handleNext,
    completed,
    submitted,
    handleDownload,
    fullSigned,
  } = usePdfScroll();

  React.useEffect(() => {
    if (completed || submitted) {
      setStarted('Finish');
    }
  }, [completed, submitted]);

  return (
    <>
      <TaskPropertyMobile properties={props.properties} />
      <WBBox p={2} height="100%">
        <PageSelector current={started}>
          <PageSelector.Page value={'Sign'}>
            <>
              <Container>
                <RowContainer>
                  <PdfContainer>
                    <PdfSign
                      ref={ref}
                      height={'100%'}
                      documentUrl={props.documentUrl}
                      annotations={
                        fullSigned ? null : props.taskGuest.annotations
                      }
                    />
                  </PdfContainer>
                </RowContainer>
              </Container>
              <BottomDrawer>
                <WBFlex
                  flexDirection={['column']}
                  p={1}
                  sx={{ bgcolor: 'background.paper' }}
                >
                  <WBFlex padding={1} pt={0}>
                    <SignatureFieldMobileContainer
                      icon={DownloadIcon}
                      label={t('Download', { ns: 'taskbox' })}
                      onClick={() => {
                        downloadPdf(ref, props.taskGuest);
                      }}
                    />
                  </WBFlex>
                  <WBFlex gap={3} justifyContent={'center'}>
                    <WBButton
                      fullWidth
                      variant="contained"
                      sx={{
                        px: 3,
                        flex: 1,
                        backgroundColor: completed
                          ? 'success.dark'
                          : 'primary.main',
                      }}
                      onClick={completed ? undefined : handleNext}
                      disabled={disableNextButton}
                    >
                      {t(
                        completed
                          ? 'signed'
                          : isFinish
                          ? 'finishSignature'
                          : 'nextSignature',
                        {
                          ns: 'taskbox',
                        }
                      )}
                    </WBButton>
                  </WBFlex>
                </WBFlex>
              </BottomDrawer>
            </>
          </PageSelector.Page>
          <PageSelector.Page value={'Finish'}>
            <SignedBox
              downloadDocument={handleDownload}
              taskGuest={props.taskGuest}
              onNext={props.onNext}
              nextButtonText={props.nextButtonText}
            />
          </PageSelector.Page>
        </PageSelector>
      </WBBox>
    </>
  );
};

const Header = styled(WBFlex)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  flexDirection: 'column',
  background: theme.palette.background.paper,
  gap: theme.spacing(1),
  ...theme.typography.body2,
}));

const Container = styled(WBFlex)(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  height: '100%',
}));
const RowContainer = styled(WBFlex)(({ theme }) => ({
  gap: theme.spacing(2),
  flexDirection: 'column',
  flex: 1,
}));

const PdfContainer = styled(WBBox)(({ theme }) => ({
  height: `calc(100% - ${theme.spacing(35)})`,
}));
